import * as z from "zod/v4";

export const getGoogleMerchantCenterIntegration = {
  name: "getGoogleMerchantCenterIntegration" as const,
  input: z.null(),
  output: z.object({
    connected: z.boolean(),
    merchantId: z.string().nullable(),
    ucpEnabled: z.boolean(),
  }),
};
